export default __webpack_public_path__ + "static/media/jobs3.a346ff11.svg";